import {
  ERROR_TYPE__FINISH_SETUP,
  NEW_ID,
} from '../../../../common/constants/index.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import Archive from './Archive.js'
import Nickname from './Nickname.js'
import ShippingMethods from './ShippingMethods.js'
import {
  formSelector,
  getState,
  onlyIfAutoForm,
  updateForm,
  useSelector,
} from '../../../../store.js'
import {
  setShipper,
  shipperSelector,
  uspsShipIntegrationIssueSelector,
} from '../../../../data/shippers.js'
import {showGlobalError} from '../../../GlobalErrorMessage.js'
import api from '../../../../common/api.js'
import {isPresent} from '../../../../common/utils.js'
import {showConfirmMessageModal} from '../../../../common/components/Modal/ConfirmMessageModal.js'
import {
  baseSaveParamsSelector,
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  goToShipperSettings,
} from '../ShippersFunctions.js'
import {redirect} from '../../../../common/location.js'
import {USPS_SHIP} from '../../../../common/constants/ShipperNames.js'
import Checkbox from '../../../../common/components/Checkbox.js'
import TextInput from '../../../../common/components/TextInput.js'
import verde from '../../../../common/verde.js'
import Zelect from '../../../../common/components/Zelect.js'
import {useMemo} from 'react'

function mapCreds(vendorConfig, userInfo) {
  let merchant_crid = vendorConfig.merchant_crid || ''
  let merchant_outbound_mid = vendorConfig.merchant_outbound_mid || ''
  let merchant_manifest_mid = vendorConfig.merchant_manifest_mid || ''
  let merchant_return_mid = vendorConfig.merchant_return_mid || ''
  let merchant_eps = vendorConfig.merchant_eps || ''
  const merchant_rate_holder_crid = vendorConfig.merchant_rate_holder_crid || ''
  const merchant_rate_holder_eps = vendorConfig.merchant_rate_holder_eps || ''
  const has_nsa = !!(merchant_rate_holder_crid || merchant_rate_holder_eps)
  let hasBeenAutoCorrected = false

  if (!merchant_crid) {
    merchant_crid = userInfo.mail_owners[0]?.crid || ''

    if (merchant_crid) {
      hasBeenAutoCorrected = true
    }
  }
  let mids = (
    userInfo.mail_owners.find((mo) => mo.crid === merchant_crid)?.mids || []
  ).filter(
    (mid) =>
      merchant_outbound_mid !== mid &&
      merchant_manifest_mid !== mid &&
      merchant_return_mid !== mid,
  )

  if (!merchant_outbound_mid) {
    merchant_outbound_mid = mids.shift() || ''

    if (merchant_outbound_mid) {
      hasBeenAutoCorrected = true
    }
  }

  if (!merchant_manifest_mid) {
    merchant_manifest_mid = mids.shift() || ''

    if (merchant_manifest_mid) {
      hasBeenAutoCorrected = true
    }
  }

  if (!merchant_return_mid) {
    merchant_return_mid = mids.shift() || ''

    if (merchant_return_mid) {
      hasBeenAutoCorrected = true
    }
  }

  if (!merchant_eps) {
    merchant_eps = userInfo.payment_accounts[0]?.eps || ''

    if (merchant_eps) {
      hasBeenAutoCorrected = true
    }
  }

  return {
    merchant_crid,
    merchant_outbound_mid,
    merchant_manifest_mid,
    merchant_return_mid,
    merchant_eps,
    merchant_rate_holder_crid,
    merchant_rate_holder_eps,
    has_nsa,
    hasBeenAutoCorrected,
  }
}

export async function showUSPSSetupModal({shipperID, needsSetupFinished}) {
  const shipper = shipperSelector(getState(), {shipperID})
  let userInfo
  let initialValues

  try {
    const {json} = await verde.get(`/usps_ship/info/${shipperID}`)
    userInfo = json

    initialValues = mapCreds(shipper.vendor_config, userInfo)
  } catch (error) {
    showGlobalError(
      {
        summary:
          'Error requesting USPS user info. Reauthorize your USPS account.',
        details: error.error_message || error.message,
      },
      error,
    )

    return
  }

  await showConfirmMessageModal({
    title: needsSetupFinished ? 'You’re Almost Finished' : 'Edit Credentials',
    Message: ({form, errors, updateModalForm, setModalFormValue}) => {
      const cridOptions = useMemo(
        () =>
          userInfo.mail_owners.map(({crid}) => ({value: crid, display: crid})),
        [],
      )

      const midOptions = useMemo(
        () =>
          (
            userInfo.mail_owners.find(
              ({crid}) => crid === form.confirmValue.merchant_crid,
            )?.mids || []
          ).map((mid) => ({value: mid, display: mid})),
        [form.confirmValue.merchant_crid],
      )

      const epsOptions = useMemo(
        () =>
          userInfo.payment_accounts.map(({eps}) => ({
            value: eps,
            display: eps,
          })),
        [],
      )

      return (
        <div>
          {needsSetupFinished && (
            <>
              <p className="fs-01 lh-md margin-bottom-15">
                <strong>
                  To finalize setting up your USPS Business account, you need to
                  still manually enter your MID, CRID and EPS info in Ordoro
                  settings.
                </strong>
              </p>
              <p className="fs-01 lh-md margin-bottom-20">
                Check out this handy{' '}
                <a
                  className="btn btn--link border-underline darkest v-align-base"
                  href="https://support.ordoro.com/how-do-i-connect-my-usps-business-account-to-ordoro/"
                >
                  <strong>support article</strong>
                </a>{' '}
                for help.
              </p>
            </>
          )}
          {form.confirmValue.hasBeenAutoCorrected && (
            <div className="alert alert--warning fs-n0 inline-block margin-bottom-20">
              Values have been automatically adjusted to reflect your authorized
              USPS account. Make sure to save these changes by clicking{' '}
              <strong>Update</strong>.
            </div>
          )}
          <div className="margin-bottom-20">
            <Zelect
              label="Merchant CRID"
              id="merchant_crid"
              value={form.confirmValue.merchant_crid}
              options={cridOptions}
              onChange={(option) => {
                const merchant_crid = option.value
                const {mids} = userInfo.mail_owners.find(
                  ({crid}) => crid === merchant_crid,
                )

                updateModalForm({
                  confirmValue: {
                    ...form.confirmValue,
                    merchant_crid: merchant_crid,
                    merchant_outbound_mid: mids[0],
                    merchant_manifest_mid: mids[1],
                    merchant_return_mid: mids[2],
                  },
                })
              }}
              errorMessage={errors.merchant_crid}
              onInvalidOption={(value) => ({
                display: `${value} Not Found`,
              })}
            />
          </div>
          <div className="margin-bottom-20">
            <Zelect
              label="Merchant Outbound MID"
              id="merchant_outbound_mid"
              options={midOptions}
              value={form.confirmValue.merchant_outbound_mid}
              onChange={(option) =>
                setModalFormValue(
                  'confirmValue.merchant_outbound_mid',
                  option.value,
                )
              }
              errorMessage={errors.merchant_outbound_mid}
              onInvalidOption={(value) => ({
                display: `${value} Not Found`,
              })}
            />
          </div>
          <div className="margin-bottom-20">
            <Zelect
              label="Merchant Manifest/Master MID"
              id="merchant_manifest_mid"
              options={midOptions}
              value={form.confirmValue.merchant_manifest_mid}
              onChange={(option) =>
                setModalFormValue(
                  'confirmValue.merchant_manifest_mid',
                  option.value,
                )
              }
              errorMessage={errors.merchant_manifest_mid}
              onInvalidOption={(value) => ({
                display: `${value} Not Found`,
              })}
            />
          </div>
          <div className="margin-bottom-20">
            <Zelect
              label="Merchant Return MID"
              id="merchant_return_mid"
              options={midOptions}
              value={form.confirmValue.merchant_return_mid}
              onChange={(option) =>
                setModalFormValue(
                  'confirmValue.merchant_return_mid',
                  option.value,
                )
              }
              errorMessage={errors.merchant_return_mid}
              onInvalidOption={(value) => ({
                display: `${value} Not Found`,
              })}
              addEmptyOption={!form.confirmValue.merchant_return_mid}
            />
          </div>
          <div className="margin-bottom-20">
            <Zelect
              label="Merchant EPS (EPA)"
              id="merchant_eps"
              options={epsOptions}
              value={form.confirmValue.merchant_eps}
              onChange={(option) =>
                setModalFormValue('confirmValue.merchant_eps', option.value)
              }
              errorMessage={errors.merchant_eps}
              onInvalidOption={(value) => ({
                display: `${value} Not Found`,
              })}
            />
          </div>
          <div className="margin-top-20">
            <Checkbox
              label="I have NSA rates"
              id="has_nsa"
              checked={form.confirmValue.has_nsa}
              onChange={() => {
                const has_nsa = !form.confirmValue.has_nsa

                updateModalForm({
                  confirmValue: {
                    ...form.confirmValue,
                    has_nsa,
                    merchant_rate_holder_crid:
                      (has_nsa &&
                        shipper.vendor_config.merchant_rate_holder_crid) ||
                      '',
                    merchant_rate_holder_eps:
                      (has_nsa &&
                        shipper.vendor_config.merchant_rate_holder_eps) ||
                      '',
                  },
                })
              }}
            />
          </div>
          {form.confirmValue.has_nsa && (
            <>
              <div className="form-list-item bigger margin-top-20 margin-bottom-20">
                <TextInput
                  label="Merchant Rate Holder CRID"
                  id="merchant_rate_holder_crid"
                  value={form.confirmValue.merchant_rate_holder_crid}
                  onChange={(value) =>
                    updateModalForm({
                      confirmValue: {
                        ...form.confirmValue,
                        merchant_rate_holder_crid: value,
                      },
                      hasChanged_merchant_rate_holder_crid: true,
                    })
                  }
                  errorMessage={
                    form.hasChanged_merchant_rate_holder_crid &&
                    errors.merchant_rate_holder_crid
                  }
                  required
                />
              </div>
              <div className="form-list-item bigger margin-bottom-20">
                <TextInput
                  label="Merchant Rate Holder EPS (EPA)"
                  id="merchant_rate_holder_eps"
                  value={form.confirmValue.merchant_rate_holder_eps}
                  onChange={(value) =>
                    updateModalForm({
                      confirmValue: {
                        ...form.confirmValue,
                        merchant_rate_holder_eps: value,
                      },
                      hasChanged_merchant_rate_holder_eps: true,
                    })
                  }
                  errorMessage={
                    form.hasChanged_merchant_rate_holder_eps &&
                    errors.merchant_rate_holder_eps
                  }
                  required
                />
              </div>
            </>
          )}
        </div>
      )
    },
    confirmText: 'Update',
    cancelText: 'Cancel',
    confirmValue: {...initialValues},
    errorsSelector(state, {formName}) {
      const errors = {}
      const {
        confirmValue: {
          merchant_crid,
          merchant_outbound_mid,
          merchant_manifest_mid,
          merchant_return_mid,
          merchant_eps,
          has_nsa,
          merchant_rate_holder_crid,
          merchant_rate_holder_eps,
        },
      } = formSelector(state, {formName})

      const mo = userInfo.mail_owners.find(({crid}) => crid === merchant_crid)

      if (!mo) {
        errors.merchant_crid = 'CRID does not match authorization'
        errors.preventSave = true
      }

      const validMIDs = mo?.mids

      if (validMIDs && !validMIDs.includes(merchant_outbound_mid)) {
        errors.merchant_outbound_mid =
          'Merchant Outbound MID does not match authorization'
        errors.preventSave = true
      }

      if (validMIDs && !validMIDs.includes(merchant_manifest_mid)) {
        errors.merchant_manifest_mid =
          'Merchant Master MID does not match authorization'
        errors.preventSave = true
      }

      if (
        isPresent(merchant_return_mid) &&
        validMIDs &&
        !validMIDs.includes(merchant_return_mid)
      ) {
        errors.merchant_return_mid = 'Return MID does not match authorization'
        errors.preventSave = true
      }

      const epsList = userInfo.payment_accounts.map(({eps}) => eps)

      if (!epsList.includes(merchant_eps)) {
        errors.merchant_eps = 'Merchant EPS does not match authorization'
        errors.preventSave = true
      }

      if (has_nsa) {
        if (!isPresent(merchant_rate_holder_crid)) {
          errors.merchant_rate_holder_crid =
            'Merchant Rate Holder CRID is required'
          errors.preventSave = true
        }

        if (!isPresent(merchant_rate_holder_eps)) {
          errors.merchant_rate_holder_eps =
            'Merchant Rate Holder EPS is required'
          errors.preventSave = true
        }
      }

      return errors
    },
    async onResolve({outcome}) {
      if (!outcome) {
        return
      }

      const params = {
        merchant_crid: outcome.merchant_crid.trim(),
        merchant_outbound_mid: outcome.merchant_outbound_mid.trim(),
        merchant_manifest_mid: outcome.merchant_manifest_mid.trim(),
        merchant_return_mid: outcome.merchant_return_mid.trim() || null,
        merchant_eps: outcome.merchant_eps.trim(),
        merchant_rate_holder_crid:
          (outcome.has_nsa && outcome.merchant_rate_holder_crid.trim()) || null,
        merchant_rate_holder_eps:
          (outcome.has_nsa && outcome.merchant_rate_holder_eps.trim()) || null,
      }

      const {json: shipper} = await api.put(`/shipper/${shipperID}/`, params)

      if (shipper.id) {
        setShipper(shipper)
      }
    },
  })
}

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  return baseShipperFormErrorsSelector(state, {formName})
}

export function initialFormSelector(state, {shipper}) {
  return baseShipperInitialFormSelector(state, {shipper, vendor: USPS_SHIP})
}

export function authorize(formName) {
  const form = formSelector(getState(), {
    formName,
  })

  const params = {
    shipper_id: form.id !== NEW_ID ? form.id : undefined,
  }

  return redirect(null, ['verde', 'usps_ship', 'start'], params)
}

export async function saveShipperUSPSShip(formName) {
  let [shipperID, params] = baseSaveParamsSelector(getState(), {formName})

  if (shipperID === NEW_ID) {
    return
  }

  updateForm(formName, {isSaving: true})

  try {
    const {json} = await api.put(`/shipper/${shipperID}/`, params)

    goToShipperSettings()

    setShipper(json)
  } catch (err) {
    showGlobalError(
      {
        details: err.error_message || err.message,
        summary: 'There was an error while saving shipper.',
      },
      err,
    )
  } finally {
    updateForm(formName, {isSaving: false})
  }
}

function USPSShipForm({formName, form}) {
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))
  const isNew = form.id === NEW_ID
  const shipper = useSelector((state) =>
    shipperSelector(state, {shipperID: form.id}),
  )
  const needsSetupFinished =
    useSelector((state) =>
      uspsShipIntegrationIssueSelector(state, {shipperID: form.id}),
    )?.integrationIssue?.errorType === ERROR_TYPE__FINISH_SETUP

  return (
    <div className="settings-list-item-form-wrap settings-list-item-form-cp clear-both">
      <div className="medium-6 columns">
        {!isNew && (
          <fieldset>
            <ul className="form-list list list--no-style">
              {needsSetupFinished ? (
                <li className="form-list-item alert alert--warning margin-bottom-20">
                  <p className="fs-01 lh-md margin-bottom-5">
                    <strong>Additional action is required.</strong>
                  </p>
                  <p className="fs-00 lh-md margin-bottom-10">
                    To complete the setup process, add your USPS CRID, EPS and
                    MIDs.
                  </p>
                  <ButtonPrimary
                    size="sm"
                    onClick={() =>
                      showUSPSSetupModal({
                        shipperID: form.id,
                        needsSetupFinished,
                      })
                    }
                  >
                    Add Credentials
                  </ButtonPrimary>
                </li>
              ) : (
                <li className="form-list-item alert alert--neutral margin-bottom-20">
                  <p className="fs-01 lh-md margin-bottom-7">
                    <strong>Your USPS Ship account is setup.</strong>
                  </p>
                  <ButtonPrimary
                    isOutlined
                    size="x-sm"
                    onClick={() =>
                      showUSPSSetupModal({
                        shipperID: form.id,
                        needsSetupFinished,
                      })
                    }
                  >
                    Edit Credentials
                  </ButtonPrimary>
                </li>
              )}
              <Nickname formName={formName} />
              <li className="list__item margin-top-25">
                <dl className="list">
                  <dt className="lh-sm-md margin-bottom-0">Merchant CRID:</dt>
                  <dd>{shipper.vendor_config.merchant_crid || 'unset'}</dd>
                </dl>
              </li>
              <li className="list__item">
                <dl className="list">
                  <dt className="lh-sm-md margin-bottom-0">
                    Merchant Outbound MID:{' '}
                  </dt>
                  <dd>
                    {shipper.vendor_config.merchant_outbound_mid || 'unset'}
                  </dd>
                </dl>
              </li>
              <li className="list__item">
                <dl className="list">
                  <dt className="lh-sm-md margin-bottom-0">
                    Merchant Manifest/Master MID:
                  </dt>
                  <dd>
                    {shipper.vendor_config.merchant_manifest_mid || 'unset'}
                  </dd>
                </dl>
              </li>
              {shipper.vendor_config.merchant_return_mid && (
                <li className="list__item">
                  <dl className="list">
                    <dt className="lh-sm-md margin-bottom-0">
                      Merchant Return MID:
                    </dt>
                    <dd>{shipper.vendor_config.merchant_return_mid}</dd>
                  </dl>
                </li>
              )}
              <li className="list__item">
                <dl className="list">
                  <dt className="lh-sm-md margin-bottom-0">
                    Merchant EPS (EPA):
                  </dt>
                  <dd>{shipper.vendor_config.merchant_eps || 'unset'}</dd>
                </dl>
              </li>
              {shipper.vendor_config.merchant_rate_holder_crid && (
                <li className="list__item">
                  <dl className="list">
                    <dt className="lh-sm-md margin-bottom-0">
                      Merchant Rate Holder CRID:
                    </dt>
                    <dd>{shipper.vendor_config.merchant_rate_holder_crid}</dd>
                  </dl>
                </li>
              )}
              {shipper.vendor_config.merchant_rate_holder_eps && (
                <li className="list__item">
                  <dl className="list">
                    <dt className="lh-sm-md margin-bottom-0">
                      Merchant Rate Holder EPS (EPA):
                    </dt>
                    <dd>{shipper.vendor_config.merchant_rate_holder_eps}</dd>
                  </dl>
                </li>
              )}

              <ShippingMethods formName={formName} />
              <li className="list__item list__item--no-style padding-bottom-20 divider--bottom">
                <ButtonPrimary
                  className="btn--primary-alt"
                  isLoading={form.isSaving}
                  isDisabled={errors.preventSave}
                  onClick={() => saveShipperUSPSShip(formName)}
                >
                  Update
                </ButtonPrimary>
              </li>
            </ul>
          </fieldset>
        )}
        <fieldset>
          <ul className="form-list">
            <li className="form-list-item helper-li">
              You will be directed to the USPS admin to authorize Ordoro to use
              your USPS account to print shipping labels.
            </li>
            <li className="form-list-item margin-top-20">
              <ButtonPrimary onClick={() => authorize(formName)}>
                {isNew ? 'Authorize' : 'Reauthorize'}
              </ButtonPrimary>
              <ButtonSecondary onClick={() => goToShipperSettings()}>
                Cancel
              </ButtonSecondary>
            </li>
          </ul>
        </fieldset>
      </div>

      <div className="medium-5 columns">
        <div className="alert margin-bottom-20 alert--standard">
          <dl className="list">
            <dt className="list__title fs-00 lh-md margin-bottom-5">
              Need help configuring your USPS Ship account?
            </dt>
            <dd className="list__item fs-n0 margin-bottom-0">
              <div>
                <a
                  className="btn--link mid meta-ups-setup-help"
                  href="https://support.ordoro.com/how-do-i-connect-my-usps-business-account-to-ordoro/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  More info →
                </a>
              </div>
            </dd>
          </dl>
        </div>
        {form.id !== NEW_ID && (
          <div className="alert margin-bottom-10 alert--standard">
            <Archive formName={formName} />
          </div>
        )}
      </div>
    </div>
  )
}

export default onlyIfAutoForm(USPSShipForm, setUpShipperForm)
